<div class="bcm-hostbar">
    <div class="bcm-hostrange" *ngIf="customFilter">
        <mat-form-field appearance="outline">
            <mat-date-range-input [rangePicker]="dateRangePicker" [formGroup]="currentRange">
                <input matStartDate placeholder="Start date" formControlName="start" #dateRangeStart>
                <input matEndDate placeholder="End date" formControlName="end" #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
            </mat-date-range-input>
            <mat-datepicker-toggle matPrefix [for]="dateRangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
            <span *ngIf="currentRange.controls.start.hasError('matStartDateInvalid')"><mat-error>Invalid start date</mat-error></span>
            <span *ngIf="currentRange.controls.end.hasError('matEndDateInvalid')"><mat-error>Invalid end date</mat-error></span>
        </mat-form-field>
        <button type="button" class="bcm-hostreset" (click)="revertCustomFinalizeddtFilter()"
                title="Back to Last Month" aria-label="Back to Last Month">
            <i class="fa fa-undo" aria-hidden="true"></i>
        </button>
    </div>

    <div class="bcm-hostselect">
        <select id="bcmTimeFrame" aria-label="Time frame"
                [(ngModel)]="selectedCtDtFilter" (change)="filterDashboard($event.target.value)">
            <option value="1">This Month</option>
            <option value="2">Last Month</option>
            <option value="3">Custom</option>
        </select>
    </div>
</div>

<app-rpt-bcm-dashboard [encryptedUser]="encryptedUser"
                       [teamCode]="curTeam?.teamCode"
                       [timeFrame]="selectedCtDtFilter"
                       [customStart]="selectedCustomdtStart"
                       [customEnd]="selectedCustomdtEnd"></app-rpt-bcm-dashboard>
